<template>
  <div
    ref="myReleaseBlock"
    class="dashboard-block release-list">
    <div class="dashboard-block__heading backwardv2__title">
      <h3 class="draft-release__title-flex c-with-icon">
        <svg
          class="icon-application-timelimit svg-icon"
          width="24px"
          height="24px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 27.5 26.749">
          <path
            class="color1"
            d="M26,4V5.5H1.5V4A1.252,1.252,0,0,1,2.749,2.75h6V4.5a.5.5,
            0,0,0,1,0V2.75h8V4.5a.5.5,0,0,0,1,0V2.75h6A1.252,1.252,0,0,1,
            26,4ZM1.5,7.5H26V24a1.251,1.251,0,0,1-1.25,1.25h-22A1.251,1.251,
            0,0,1,1.5,24ZM17.75,12h4V10h-4Zm0,4h4V14h-4Zm0,4h4V18h-4Zm-6-8h4V10h-4Zm0,
            4h4V14h-4Zm0,4h4V18h-4Zm-6-8h4V10h-4Zm0,4h4V14h-4Zm0,4h4V18h-4Zm19-17.249h-6V4.5a.5.5,
            0,0,1-1,0V2.75h-8V4.5a.5.5,0,0,1-1,0V2.75h-6A1.252,1.252,0,0,0,1.5,4V5.5H26V4A1.252,
            1.252,0,0,0,24.75,2.75ZM1.5,24a1.251,1.251,0,0,0,1.249,1.25h22A1.251,1.251,0,0,0,26,
            24V7.5H1.5Zm26-20V24a2.752,2.752,0,0,1-2.75,2.75h-22A2.752,2.752,0,0,1,0,24V4A2.753,
            2.753,0,0,1,2.749,1.25h6V.5a.5.5,0,1,1,1,0v.75h8V.5a.5.5,0,1,1,1,0v.75h6A2.753,2.753,
            0,0,1,27.5,4ZM26,7.5H1.5V24a1.251,1.251,0,0,0,1.249,1.25h22A1.251,1.251,0,0,0,26,
            24ZM26,4a1.252,1.252,0,0,0-1.25-1.25h-6V4.5a.5.5,0,0,1-1,0V2.75h-8V4.5a.5.5,0,0,1-1,
            0V2.75h-6A1.252,1.252,0,0,0,1.5,4V5.5H26ZM21.749,18h-4v2h4Zm-6,0h-4v2h4Zm-6,
            0h-4v2h4Zm12-4h-4v2h4Zm-6,0h-4v2h4Zm-6,0h-4v2h4Zm12-4h-4v2h4Zm-6,0h-4v2h4Zm-6,
            0h-4v2h4Z"></path>
        </svg>
        <span class="backwardv2__title-text">配信スケジュールを確認する</span>
      </h3>
    </div>
    <div class="dashboard-block__inner application-timelimit__inner backwardv2__inner">
      <div class="application-timelimit__date-block backwardv2__date-block">
        <div class="form-item-inline form-item-inline--sp-reset">
          <date-select
            v-model="date"
            title="配信希望日"
            :min-date="minDate"
            :max-date="maxDate"
            :is-selected="false"
            class="date-select" />
        </div>
        <div class="application-timelimit__btn backwardv2__btn">
          <div
            :class="[{ 'c-btn--off': !date }]"
            class="backwardv2__btn_inner c-btn c-btn-timelimit application-timelimit__btn-inner"
            :disabled="!date"
            @click.prevent="fetchBackwardSchedules">
            <div class="backwardv2__btn_text">確認する</div>
            <span class="c-btn__icon-arrow draft-release__c-btn-arrow"></span>
          </div>
        </div>
      </div>
      <div class="application-timelimit__text-block backwardv2__text-block">
        <div class="application-timelimit__text backwardv2__text">
          リリース申請日 :
        </div>
        <div
          v-if="allStoreBackwardMinReleaseDate"
          class="application-timelimit__text-date backwardv2__text-date">
          <span class="backwardv2__big-date-text">
            {{
              allStoreBackwardMinReleaseDate | formatDate("YYYY年MM月DD日")
            }}
          </span>
          <span class="backwardv2__normal-text">（23時59分申請完了まで）</span>
        </div>
        <div
          v-else-if="allStoreBackwardMinReleaseDate===''"
          class="application-timelimit__text-expire backwardv2__text-expire">
          リリース申請日を過ぎました
        </div>
        <div
          v-else
          class="application-timelimit__text-default backwardv2__text-default">
          <span class="backwardv2__big-date-text">- - - - 年 - - 月 - - 日</span>
          <span class="backwardv2__normal-text">（23時59分申請完了まで）</span>
        </div>
        <div class="application-timelimit__notice_block backwardv2__notice_block">
          <div class="application-timelimit__text backwardv2__normal-sm-text">
            ※配信ストアのスケジュールにより変動する場合がございます
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DateSelect from '../../DateSelect'

export default {
  name: 'DashboardBackwardMinReleaseSchedulesV2',
  components: { DateSelect },
  data() {
    return {
      minDate: null,
      maxDate: null,
      date: '',
      allStoreBackwardMinReleaseDate: null,
    }
  },
  watch: {
    date() {
      this.allStoreBackwardMinReleaseDate = null
    },
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/providers')
      const providers = window._.orderBy(data, 'min_release_date', 'desc')
      const minDate = moment(
        new Date(window._.last(providers).min_release_date),
      )
      this.minDate = minDate.format('YYYY-MM-DD')
      this.maxDate = minDate.add(120, 'days').format('YYYY-MM-DD')
    },
    async fetchBackwardSchedules() {
      const { data } = await window.axios.get(
        '/api/client/providers/backward-schedules',
        {
          params: {
            release_date: this.date,
          },
        },
      )

      const businessDirection = this.isBtoB ? 'b2b' : 'b2c'
      const possibleProvisers = data.filter(provider => provider.is_possible && (provider.business_direction === 'all' || provider.business_direction === businessDirection))
      const impossibleProvisers = data.filter(provider => !provider.is_possible && (provider.business_direction === 'all' || provider.business_direction === businessDirection))

      // "全ストア同日配信の最短日" が存在するか（不可能プロバイダが0か）で分岐
      if (impossibleProvisers.length === 0) {
        // 配信日が一番早いプロバイダー順にソートして先頭をセット
        /* eslint-disable max-len */
        const sortBackwardMinReleaseDate = window._.orderBy(possibleProvisers, 'backward_min_release_date', 'asc')
        this.allStoreBackwardMinReleaseDate = sortBackwardMinReleaseDate[0].backward_min_release_date
        /* eslint-enable max-len */
      } else {
        // 存在しない場合は空文字にして、テンプレート側で「期限切れ」表示にする
        this.allStoreBackwardMinReleaseDate = ''
      }
    },
  },
}
</script>

<style scoped>

</style>
